import type {
    EFakturaCreditor,
    EFakturaPermissionId,
    EFakturaUpdateGivenPermissionRequest,
    UserId,
} from '../../../generated-types';
import { updateEfakturaPermissions } from '../../../services/eFakturaService';

export default (payload: {
    id: EFakturaPermissionId;
    creditors: EFakturaCreditor[];
    customerNumber: UserId;
    disponentName: string;
}) => {
    const issuers: EFakturaCreditor[] | undefined = payload.creditors?.map((issuer) => ({
        creditorId: issuer.creditorId,
        name: issuer.name,
        isBlocked: false,
    }));
    const request: EFakturaUpdateGivenPermissionRequest = {
        selectedIssuers: issuers,
        customerNumber: payload.customerNumber,
        disponentName: payload.disponentName,
        deviceId: window.ReactNativeProps?.deviceId,
    };
    return updateEfakturaPermissions(payload.id, request);
};
